export default {
  estudante: null,
  estudanteSimulacao: null,
  estudantes: [],
  paginacao: {},
  formSimulacao: {},
  variaveisSimulacao: [],
  variaveisImportancia: [],
  variaveisInformacoes: [],
  modelo: null,
  max_ch_unidade: 50000,
  ordenacaoBusca: {
    campo: 'nome_aluno',
    ordem: 1,
  },
  formBusca: {
    unidade: null,
    unidades: [],
    modalidade: null,
    modalidades: [],
    modelo_negocio: null,
    modelos_negocio: [],
    curso: null,
    cursos: [],
    versao: null,
    versoes: [],
    turma: null,
    turmas: [],
    id_turma: null,
    data_inicio_turma: null,
    nome: "",
    pagina: 1,
    faixa_evasao: [0, 100],
    faixa_ch: [0, 50000],
  },
}



// WEBPACK FOOTER //
// ./src/pages/estudantes/store/state.js